/*
 * @LastEditTime: 2022-06-30 19:07:51
 */

import React, { Component } from 'react';
import Header from './component/header';
import Parts from './component/parts';
import When from './component/when';
import Price from './component/price';
import Footer from './component/footer';

import './index.less';
class Intro extends Component {
    componentDidMount() {
        document.title = '新华英才测评'
    }
    render() {
        return (
            <div className="intro">
                <Header />
                <div className="section gray">
                    <div className="title">
                        <div className="text">人才测评能做什么</div>
                        <div className="desc">为您多维度识别人才，提供人岗匹配参考，把关求职者心理风险</div>
                    </div>
                    <div className="content">
                        <Parts />
                    </div>
                </div>
                <div className="section">
                    <div className="title">
                        <div className="text">何时使用人才测评</div>
                        <div className="desc">人才招聘，培训培养，人才库建设，职业规划</div>
                    </div>
                    <div className="content">
                        <When />
                    </div>
                </div>
                <div className="section gray">
                    <div className="title">
                        <div className="text">测评产品价格与介绍</div>
                        <div className="desc">
                            大五人格，职业认知能力，职业行为风险，职业胜任力测验
                        </div>
                    </div>
                    <div className="content">
                        <Price />
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default Intro;